import Dropdown from './dropdown';
import { h } from './element';
import Icon from './icon';
import { cssPrefix } from '../config';
import { tf,t } from '../locale/locale';

function buildItemWithIcon(iconName,title='') {
  return h('div', `${cssPrefix}-item`).child(new Icon(iconName,'-icon-img')).attr('title',title);
}
function getTipTitle(align){
  const tipsObj= {'left':t('toolbar.left'), 'center':t('toolbar.center'), 'right':t('toolbar.right'),'horizontal-justifyAlign':t('toolbar.justifyAlign'),'horizontal-disttibuted':t('toolbar.disttibuted'),
  'top':t('toolbar.top'), 'middle':t('toolbar.center'), 'bottom':t('toolbar.bottom'),'vertical-justifyAlign':t('toolbar.justifyAlign'),'vertical-disttibuted':t('toolbar.disttibuted')};
  return tipsObj[align];
}

export default class DropdownAlign extends Dropdown {
  constructor(aligns, align) {
    const icon = new Icon(`align-${align}`);
    const naligns = aligns.map(it => buildItemWithIcon(`align-${it}`,getTipTitle(it))
      .on('click', () => {
        this.setTitle(it);
        this.change(it);
      }));
    super(icon, 'auto', true, 'bottom-left', ...naligns);
  }

  

  setTitle(align) {
    this.title.setName(`align-${align}`);
    this.hide();
  }
}
